import React from 'react';
import '../less/uo-accounts.less';
import FAQStorybook from '@abank/abank-faq';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import tariffsData from '../enums/tariffs_data.json';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';
import hero_data from '../enums/hero_data.json';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import additionalCards from '../enums/additional_cards_data.json';
import additionalCards2Data from '../enums/additional_cards_2_data.json';
import FilesForDownloadNew from '../../../../../auxiliary-components/shared/FilesForDownloadNew';
import hero_award_img_01 from '../img/hero_award_img_01.svg';
import hero_award_img_02 from '../img/hero_award_img_02.svg';
import { aBank24forBusiness, businessAllDigitalAwardLink, businessBannerAwardFop, downloadA24, yuoTariffsLink } from '../../../../../services/urls/urls';
import BusinessOrder from '../../../../BusinessOrder';
import open_account_img_01 from '../img/open_account_img_01.png';
import open_account_img_02 from '../img/open_account_img_02.png';
import open_account_img_03 from '../img/open_account_img_03.png';
import { getSafeLinkProps } from '../../../../../helpers/utils/urlSecurity';
import { apiback } from '../../../../../config';
import daily_income_banner_img from '../img/daily_income_banner_img.png';
import DOMPurify from 'utils/sanitize';

const imagesMap = {
  hero_award_img_01,
  hero_award_img_02
};

const urlsMap = {
  businessBannerAwardFop,
  businessAllDigitalAwardLink,
};

export default function template() {
  const page = 'yuo-accounts-new';

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  const handlersMap = {
    toggleHeroModal: () => this.toggleModal()
  };

  const heroData = {
    ...hero_data,
    link: {
      ...hero_data.link,
      onClick: handlersMap[hero_data.link.onClick],
    },
    cards: hero_data.cards.map(card => ({
      ...card,
      img: imagesMap[card.img],
      href: urlsMap[card.href]
    }))
  };

  const resolveHandlers = ({ onClick, ...rest }) => ({
    ...rest,
    onClick: handlersMap[onClick]
  });

  const additionalCards2 = additionalCards2Data.map(resolveHandlers);

  return (
    <div className="yuo-accounts-new">
      <Hero
        data={heroData}
        img={hero_img}
        page={page}
      />
      <div className={`content${this.state.faqTab ? ' hidden' : ''}`}>
        <div className="daily-income-banner">
          <div className="container">
            <a className="daily-income-banner__body" {...getSafeLinkProps('/news/161', {target: '_self'})}>
              <div className="daily-income-banner__left">
                <h2 className="daily-income-banner__title" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n('YUO_ACCOUNTS_NEW_DAILY_INCOME_BANNER_TITLE'))}}></h2>
                <div className="daily-income-banner__text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n('YUO_ACCOUNTS_NEW_DAILY_INCOME_BANNER_TEXT'))}}></div>
              </div>
              <img className="daily-income-banner__image" src={daily_income_banner_img} alt={this.l10n('YUO_ACCOUNTS_NEW_DAILY_INCOME_BANNER_TITLE')} />
            </a>
          </div>
        </div>
        <Tariffs
          items={tariffsData}
          title={'YUO_ACCOUNTS_NEW_CARDS_TARIFFS_TITLE'}
          btnLink={yuoTariffsLink}
          btnText={'YUO_ACCOUNTS_NEW_CARDS_TARIFFS_BTN'}
        />
        <div className="open-account" id="open-account">
          <div className="container">
            <h2 className="open-account__title">{this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_TITLE')}</h2>
            <div className="open-account__body">
              <div className="open-account__item item-open-account item-open-account_1">
                <div className="item-open-account__top">
                  <img className="item-open-account__img" src={open_account_img_01} alt={this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_01_TITLE')} />
                </div>
                <div className="item-open-account__bottom">
                  <h3 className="item-open-account__title">
                    {this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_01_TITLE')}
                  </h3>
                  <div className="item-open-account__text">
                    <p>{this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_01_TEXT')}</p>
                    <a {...getSafeLinkProps(apiback('API_PAGES') + '/media/file?path=business/yuo/paket_docs.pdf')}>
                      {this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_01_LINK')}
                    </a>
                  </div>
                  <a {...getSafeLinkProps('/branches', {target: "_self"})} className="item-open-account__btn">
                    {this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_01_BTN')}
                  </a>
                </div>
              </div>
              <div className="open-account__item item-open-account">
                <div className="item-open-account__top">
                  <img className="item-open-account__img" src={open_account_img_02} alt={this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_02_TITLE')} />
                </div>
                <div className="item-open-account__bottom">
                  <h3 className="item-open-account__title">
                    {this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_02_TITLE')}
                  </h3>
                  <div className="item-open-account__text">
                    <p>{this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_02_TEXT_01')}</p>
                    <p>{this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_02_TEXT_02')} <a {...getSafeLinkProps(downloadA24, {target: "_self"})}>{this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_02_LINK')}</a></p>
                  </div>
                  <button className="item-open-account__btn" onClick={() => this.toggleModal()}>
                    {this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_02_BTN')}
                  </button>
                </div>
              </div>
              <div className="open-account__item item-open-account">
                <div className="item-open-account__top">
                  <img className="item-open-account__img" src={open_account_img_03} alt={this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_03_TITLE')} />
                </div>
                <div className="item-open-account__bottom">
                  <h3 className="item-open-account__title">
                    {this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_03_TITLE')}
                  </h3>
                  <div className="item-open-account__text">
                    <p>{this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_03_TEXT_01')}</p>
                    <p>{this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_03_TEXT_02')} <a {...getSafeLinkProps(downloadA24, {target: "_self"})}>{this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_03_LINK')}</a></p>
                  </div>
                  <a {...getSafeLinkProps(aBank24forBusiness, {target: "_self"})} className="item-open-account__btn">
                    {this.l10n('YUO_ACCOUNTS_NEW_OPEN_ACCOUNT_03_BTN')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <QuestionsAdminNew
          widget={questionsWidget}
          toggleFaqTab={this.toggleFaqTab}
          title={'YUO_ACCOUNTS_NEW_QUESTIONS_TITLE'}
          loader={this.state.loader}
        />
        <AdditionalProduct
          items={additionalCards}
          title={'YUO_ACCOUNTS_NEW_ADDITIONAL_PRODUCT_TITLE'}
        />
        <AdditionalProduct
          items={additionalCards2}
          title={'YUO_ACCOUNTS_NEW_ADDITIONAL_PRODUCT_2_TITLE'}
          className="additional-product_2"
        />
        <FilesForDownloadNew
          widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
          loader={this.state.loader}
        />
      </div>
      <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('YUO_ACCOUNTS_NEW_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('YUO_ACCOUNTS_NEW_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
      </div>
      {this.state.showModal && 
        <BusinessOrder attribute="yuo" closeModal={this.toggleModal} />
      }
    </div>
  )
}
